import { useButtonStyles } from '@/shared/components/ui/button/button.styles';
import { LoadingBtnContent } from '@/shared/components/ui/button/loading/loading-btn-content.component';
import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  id: string;
  color?: 'primary' | 'secondary' | 'danger';
  variant?: 'contained' | 'outlined';
  loading?: {
    state: boolean;
    children?: ReactNode;
  };
};

/**
 * @todo Mudar o botao para loading qnd estiver carregando algo.
 */
export const Button: FC<ButtonProps> = ({
  id,
  children,
  color = 'primary',
  className,
  loading,
  variant = 'contained',
  type = 'button',
  ...rest
}) => {
  const { buttonStyle } = useButtonStyles();

  return (
    <button
      id={id}
      type={type}
      className={twMerge(
        buttonStyle({ color, variant, loading: loading?.state }),
        className,
      )}
      {...rest}
    >
      {loading?.state ? (
        <LoadingBtnContent
          loadingChildren={loading.children}
          children={children}
        />
      ) : (
        children
      )}
    </button>
  );
};
